import { render, staticRenderFns } from "./Chats.vue?vue&type=template&id=adfedfaa&"
import script from "./Chats.vue?vue&type=script&lang=js&"
export * from "./Chats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports